import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-column gap-1"
};
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-color-secondary"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "w-full flex align-items-center flex-column p-5"
};
const _hoisted_5 = {
  key: 1,
  class: "w-full flex align-items-center flex-column p-5 text-color-secondary"
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_8 = {
  class: "protocols-view-layout border-1 surface-border border-round"
};
const _hoisted_9 = {
  class: "protocols-view-nav"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "protocols-view-label"
};
const _hoisted_12 = {
  class: "protocols-view-content"
};
const _hoisted_13 = {
  class: "text-base font-semibold mb-3"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  key: 1,
  class: "text-sm text-color-secondary font-italic"
};
const _hoisted_16 = {
  class: "flex justify-content-end border-top-1 surface-border pt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner");
  const _component_SelectButton = _resolveComponent("SelectButton");
  const _component_Button = _resolveComponent("Button");
  const _component_Dialog = _resolveComponent("Dialog");
  return _openBlock(), _createBlock(_component_Dialog, {
    visible: $data.clientProtocolsViewDialog.showDialog,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => $data.clientProtocolsViewDialog.showDialog = $event),
    appendTo: "body",
    modal: "",
    breakpoints: {
      '960px': '75vw',
      '640px': '100vw'
    },
    style: {
      width: '65vw'
    },
    draggable: false,
    resizable: false
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("h1", {
      class: "m-0 text-900 font-semibold text-xl line-height-3"
    }, "Client Protocols", -1)), $data.brand ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createTextVNode(_toDisplayString($data.brand.brand_name) + " ", 1), $data.activeSource === $data.protocolScope.COMPANY && $data.brand.company?.company_name ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_cache[3] || (_cache[3] = _createTextVNode(" · shared from ", -1)), _createElementVNode("b", null, _toDisplayString($data.brand.company.company_name), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_Button, {
      label: "Close",
      onClick: _cache[1] || (_cache[1] = $event => $data.closeClientProtocolsViewDialog()),
      class: "p-button-text"
    })])]),
    default: _withCtx(() => [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_ProgressSpinner, {
      strokeWidth: "3",
      style: {
        "width": "40px",
        "height": "40px"
      }
    }), _cache[5] || (_cache[5] = _createElementVNode("span", {
      class: "mt-2 text-sm"
    }, "Loading protocols...", -1))])) : !$data.brand ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [_createElementVNode("i", {
      class: "pi pi-briefcase mb-2",
      style: {
        "font-size": "1.75rem"
      }
    }, null, -1), _createElementVNode("span", {
      class: "text-sm"
    }, "Select a brand to view its client protocols.", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [$options.sources.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_SelectButton, {
      modelValue: $data.activeSource,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.activeSource = $event),
      options: $options.sources,
      optionLabel: "label",
      optionValue: "key",
      allowEmpty: false
    }, null, 8, ["modelValue", "options"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.protocolSections, section => {
      return _openBlock(), _createElementBlock("button", {
        type: "button",
        key: section.key,
        class: _normalizeClass(["protocols-view-item", {
          'is-active': $data.activeProtocolKey === section.key
        }]),
        onClick: $event => $data.activeProtocolKey = section.key
      }, [_createElementVNode("span", {
        class: _normalizeClass(["protocols-view-dot", {
          'is-filled': $options.hasProtocolContent(section.key)
        }])
      }, null, 2), _createElementVNode("span", _hoisted_11, _toDisplayString(section.label), 1)], 10, _hoisted_10);
    }), 128))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($options.activeProtocolLabel), 1), $options.hasProtocolContent($data.activeProtocolKey) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "protocols-view-html ql-editor",
      innerHTML: $options.currentProtocols[$data.activeProtocolKey]
    }, null, 8, _hoisted_14)) : (_openBlock(), _createElementBlock("div", _hoisted_15, " No protocol has been added for this stage yet. "))])])]))]),
    _: 1
  }, 8, ["visible"]);
}